import { $, $$, body } from "@utils/dom";
import { on, off } from "@utils/listener";

import * as cart from '@vendors/shopify/theme-cart/theme-cart';

class Cart {
  constructor(el, emitter, callback) {
    this.el = el;
    this.emitter = emitter;
    this.callback = callback;

    this.initialized = false;

    this._render = this._render.bind(this);
    this._fetch = this._fetch.bind(this);

    this._update = this._update.bind(this);
    // this._updateState = this._updateState.bind(this);
  }


  init() {
    this.initialized = true;

    this.cartItems = null;

    this.content = $('[data-cart-content]', this.el);

    this._fetch();
    this._bindEvents();
  }

  destroy() {
    this._clearCartUI();
    this._unbindEvents();

    this.el = null;

    this.content = null;

    this.initialized = false;

    this._render = null;
    this._fetch = null;

    this._update = null;
  }

  _bindEvents() {
    this.emitter.on("SiteCart.update", this._update);
  }
  _unbindEvents() {
    this.emitter.off("SiteCart.update", this._update);
  }

  _fetch(callback = null){
    fetch(`${window.Shopify.routes.root ? window.Shopify.routes.root : '/'}?view=cart`)
    .then((response) => {
      if(response.ok) {
        return response.text()
      }
      return Promise.reject(response);
    })
    .then(response => {
      this._render(response);
      if(callback) callback();
    });
  }

  _render(html){
    this._clearCartUI();

    this.content.innerHTML = html;

    this.cartItems = [...$$('.site-cart__item', this.el)].map(el => new CartItem(el, this.emitter, this.el));

    if ($('.site-cart__note', this.el)) this.cartNote = new CartNote($('.site-cart__note', this.el), this.emitter);
  }

  _clearCartUI(){
    if (this.cartItems) this.cartItems.forEach(el => el.destroy());
    if (this.cartNote) this.cartNote.destroy();

    this.cartItems = null;
    this.cartNote = null;
  }

  _update(allowCallback=true){
    let callback = null;
    if (allowCallback) callback = this.callback;

    this._fetch(callback);
  }
}

class CartNote {
  constructor(el, emitter) {

    this.el = el;
    this.emitter = emitter;

    this._toggle = this._toggle.bind(this);
    this._submit = this._submit.bind(this);
    this._edit = this._edit.bind(this);

    this.init();
  }

  init(){
    this.toggler = $('[data-note-toggle]', this.el);
    this.content = $('[data-note-content]', this.el);
    this.editBtn = $('[data-note-edit]', this.el);
    this.note = $('[data-note]', this.el);
    this.form = $('form', this.el);

    this._expanded = false;

    this._bindEvents();
  }

  destroy(){
    this._unbindEvents();

    this.key = null;

    this.el = null;
    this.emitter = null;

    this.toggler = null;
    this.content = null;
    this.editBtn = null;
    this.note = null;

    this._toggle = null;
    this._open = null;
    this._close = null;
    this._submit = null;
    this._edit = null;

    this._expanded = null;
  }

  _bindEvents(){
    if (this.toggler) on(this.toggler, "click", this._toggle);
    if (this.editBtn) on(this.editBtn, "click", this._edit);
    if (this.form) on(this.form, "submit", this._submit);
  }

  _unbindEvents(){
    if (this.toggler) off(this.toggler, "click", this._toggle);
    if (this.editBtn) off(this.editBtn, "click", this._edit);
    if (this.form) off(this.form, "submit", this._submit);
  }

  _toggle(){
    if (this._expanded) {
      this._close();
    } else {
      this._open();
    }
  }

  _open(){
    if (this._expanded) return;

    this._expanded = true;

    this.content.setAttribute('aria-hidden', false);
    this.toggler.setAttribute('aria-expanded', true);
  }

  _close(){
    if (!this._expanded) return;

    this._expanded = false;
    this.content.setAttribute('aria-hidden', true);
    this.toggler.setAttribute('aria-expanded', false);
  }

  _submit(event){
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    const data = new FormData(this.form);

    cart.updateNote(data.get("note")).then(state => {
      if (state.note != "") {
        this.note.innerHTML = state.note;
        this.el.classList.add('--filled');
      }
    });
  }

  _edit(event){
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    this.el.classList.remove('--filled');
  }

}

class CartItem {
  constructor(el, emitter, parent) {

    this.el = el;
    this.emitter = emitter;
    this.parent = parent;

    this._removeItem = this._removeItem.bind(this);
    this._incrementItem = this._incrementItem.bind(this);
    this._onError = this._onError.bind(this);

    this.init();
  }

  init(){
    this.key = this.el.getAttribute('data-key');

    this.remove = $('[data-remove]',this.el);
    this.increments = [...$$('[data-increment]', this.el)];

    this._bindEvents();
  }

  destroy(){
    this._unbindEvents();

    this.key = null;

    this.el = null;
    this.emitter = null;

    this.remove = null;

    this._removeItem = null;
  }

  _bindEvents(){
    if (this.remove) on(this.remove, "click", this._removeItem);
    if (this.increments) on(this.increments, "click", this._incrementItem);
  }

  _unbindEvents(){
    if (this.remove) off(this.remove, "click", this._removeItem);
    if (this.increments) off(this.increments, "click", this._incrementItem);
  }

  _removeItem(event){
    cart.removeItem(this.key).then(state => {
      this.emitter.emit('SiteCart.update', false);
    });
  }

  _incrementItem(event){
    const quantity = parseInt(event.currentTarget.getAttribute('data-increment'));

    cart.updateItem(this.key, { quantity }).then(state => {
      this.emitter.emit('SiteCart.update', false);
    }).catch(this._onError);
  }

  /**
   *
   * Handles error messages from Shopify Cart API
   *
   */
  _onError(error) {
    let errorElement = null;
    const errorElementExisting = $(`.site-cart__itemError`, this.el);

    if(errorElementExisting) {
      errorElement = errorElementExisting;
    } else {
      errorElement = document.createElement('div');
      errorElement.classList.add(`site-cart__itemError`);
    }

    // get error messages, if any
    error.json().then((json) => {
      if(json.message) errorElement.innerHTML = `<p>${json.message}</p>`;
    });

    // append error
    this.el.appendChild(errorElement);
  }

}

export default Cart;
